import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";

const O_AUTH_URL = "api/ds_login";

@Injectable()
export class OAuthService {
  constructor(public _http: HttpClient) {}
  // 岗位列表接口 实习就业首页岗位搜索接口
  authorize(token: String) {
    return this._http.post(O_AUTH_URL, {token});
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/oauth/oauth.service.ts